import { render, staticRenderFns } from "./BusinessActiveFilters.vue?vue&type=template&id=23f471a2&scoped=true&"
import script from "./BusinessActiveFilters.vue?vue&type=script&lang=js&"
export * from "./BusinessActiveFilters.vue?vue&type=script&lang=js&"
import style0 from "./BusinessActiveFilters.vue?vue&type=style&index=0&id=23f471a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f471a2",
  null
  
)

export default component.exports